<template>
  <b-modal
    title="Add Price"
    ref="add-price-modal"
    id="add-price-modal"
    size="lg"
    ok-title="Add"
    @ok="addPrice"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
  >
    <b-card class="m-0" style="font-family: NanumBarunGothic;">
      <validation-observer ref="addPriceRule" tag="form">
        <b-form-group label-for="title">
          <div style="display:inline-block; width: 10%;">TITLE<span class="text-danger">*</span></div>
          <b-form-input
            id="title"
            v-model="price.title"
            placeholder="Title"
            style="display:inline-block; width:43%; margin-left:1rem;"
          />
        </b-form-group>

        <b-form-group label-for="desc">
          <div style="display:inline-block; width: 10%;">DESCRIPTION</div>
            <b-form-input
              id="desc"
              v-model="price.desc"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
        </b-form-group>

        <b-form-group label-for="price">
          <div style="display:inline-block; width: 10%;">PRICE<span class="text-danger">*</span></div>
            <b-form-input
              id="price"
              v-model="price.price"
              type="number"
              @keypress="checkNumber"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
        </b-form-group>

        <b-form-group label-for="period">
          <div style="display:inline-block; width: 10%;">PERIOD<span class="text-danger">*</span></div>
            <vue-select
            id=id
            v-model="price.period"
            :options= periodOptions
            label=id
            style="display:inline-block; width:43%; margin-left:1rem;"
          />
        </b-form-group>

        <b-form-group label-for="analPeriod">
          <div style="display:inline-block; width: 10%;">ANAL PERIOD<span class="text-danger">*</span></div>
            <b-form-input
              id="maxAnalPeriod"
              v-model="price.maxAnalPeriod"
              type="number"
              @keypress="checkNumber"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
        </b-form-group>

        <b-form-group label-for="maxCate">
          <div style="display:inline-block; width: 10%;">MAX CATEGORIES<span class="text-danger">*</span></div>
            <b-form-input
              id="maxCateNum"
              v-model="price.maxCateNum"
              type="number"
              @keypress="checkNumber"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
        </b-form-group>

        <b-form-group label-for="maxMem">
          <div style="display:inline-block; width: 10%;">MAX MEMBERS<span class="text-danger">*</span></div>
            <b-form-input
              id="maxMemNum"
              v-model="price.maxMemNum"
              type="number"
              @keypress="checkNumber"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
        </b-form-group>

        <b-form-group label-for="menu">
          OPEN MENU<span class="text-danger"> *</span>
          <vue-select
            id="id"
            v-model="price.permissions"
            :options="perOptions"
            :multiple="true"      
            label="menu"
          />
        </b-form-group>

      </validation-observer>
    </b-card>
  </b-modal>
</template>

<script>
import { BCard, BFormGroup, BFormInput } from "bootstrap-vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import CISSettingService from '@/services/cis-setting.service'

export default {
  name: "AddPriceModal",
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    refreshData: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      roles: [],
      price: {},
      required,
      perOptions: [],
      periodOptions: ["Y", "M"],
    };
  },
  watch: {
    
  },
  methods: {
    async setPerOptions(){
      const getPerRes = await CISSettingService.perList();
      if (getPerRes.data.success) {
        this.perOptions = getPerRes.data.data;
        console.log('-- update permission options --')
        console.log(this.perOptions)
      }
    },

    checkNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    checkInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.addPriceRule.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject("The Subject field is required");
          }
        });
      });
    },
    async addPrice(e) {
      console.log('-- addPrice --')
      console.log(this.price)
      e.preventDefault();
      await this.checkInfo();

      this.$swal({
        title: "Are you sure?",
        html: `You want to add the Price!<br>&nbsp;`,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        padding: "1rem",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await CISSettingService.addPrice(this.price);
          if (response && response.status === 200) {
            this.price = {};
            this.$bvModal.hide("add-price-modal");
            this.refreshData();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `Successfully added!`,
                icon: "EditIcon",
                variant: "success",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || "Unknown error",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          }
        }
      });
    },
  },
  created() {
    this.setPerOptions()
  },
};
</script>

<style>

.modal-lg,
.modal-xl {
  max-width: 1100px;
}

</style>